import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../assets/css/Form.css';
import logo from '../assets/images/Logo.svg';
import { useForm } from './hooks/useForm';
import { map } from 'lodash';
import { ReqPost } from '../config/Requests';
import { toast } from 'react-toastify';

function ChangePassword() {
	const [values, handleChange] = useForm({
		password: '',
		password_confirmation: '',
	});
	let navigate = useNavigate();

	const { token } = useParams();

	const handleSubmit = e => {
		e.preventDefault();
		values['email'] = atob(token).split('-')[1];
		values['token'] = token;
		console.log(values);
		ReqPost('change-password', values)
			.then(() => {
				navigate(`/password-updated`);
			})
			.catch(err => {
				const { data } = err.response;
				const keys = Object.keys(data);
				map(keys, k => map(data[k], c => toast.error(c)));
			});
	};

	return (
		<div className='main-container form-bg-color form-bg-log'>
			<img src={logo} className='form-logo' alt='logo' />
			<div className='form-container'>
				<div className='form-label-vmn'>Reset Password</div>
				<div className='form-label2-vmn'>Write your new password</div>
				<span className='text-vmn'>
					Your new password must not be the same to your current password.
				</span>

				<form className='form-container-inner' onSubmit={handleSubmit}>
					<input
						className='form-input mb-3 text-center'
						type='password'
						id='password'
						name='password'
						placeholder='Password'
						value={values.password}
						onChange={handleChange}
						required
					/>
					<input
						className='form-input mb-3 text-center'
						type='password'
						id='password_confirmation'
						name='password_confirmation'
						placeholder='Password Confirmation'
						value={values.password_confirmation}
						onChange={handleChange}
						required
					/>
					<button type='submit' className='btn-send-code'>
						Confirm New Password
					</button>
				</form>
			</div>
		</div>
	);
}

export default ChangePassword;
